import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "@/lib/utils";
import {
  FRANKLIN_UPDATE_CARD_CLASS_NAME,
  FRANKLIN_UPDATE_MIN_WIDTH,
  FRANKLIN_UPDATE_SIZE_CLASS_NAME,
  FRANKLIN_UPDATE_TAIL_CLASS_NAME,
} from "./franklinUpdateVisual";

interface FranklinSpeechBubbleProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /**
   * `fixed` (default) keeps the pill's width — progress cards, whose text
   * changes every tick, must not resize. `fit` shrink-wraps a notification's
   * message between the shared min/max bounds.
   */
  sizing?: "fixed" | "fit";
}

/** White Franklin card aligned to the collapsed launcher, with a tail toward it. */
export function FranklinSpeechBubble({
  children,
  className,
  style,
  sizing = "fixed",
  ...props
}: FranklinSpeechBubbleProps) {
  return (
    <div
      className={cn(
        FRANKLIN_UPDATE_CARD_CLASS_NAME,
        sizing === "fit" && FRANKLIN_UPDATE_SIZE_CLASS_NAME,
        "relative",
        FRANKLIN_UPDATE_TAIL_CLASS_NAME,
        className
      )}
      style={sizing === "fixed" ? { width: FRANKLIN_UPDATE_MIN_WIDTH, ...style } : style}
      {...props}
    >
      {children}
    </div>
  );
}

FranklinSpeechBubble.displayName = "FranklinSpeechBubble";
